// Price List (owner 2026-10-10/11): pure helpers (no "@/" imports) so Jest can test them.
import { rupiah } from "./format";

export const KOLOM_HARGA = [
  ["harga_enduser", "Enduser"],
  ["harga_reseller", "Reseller"],
  ["harga_member", "Member"],
];

// search by name or code (case-insensitive) + category filter ("" = all)
export function saring(barang, q = "", kategori = "") {
  const kata = q.trim().toLowerCase();
  return (barang || []).filter((b) => (!kategori || b.kategori_kode === kategori)
    && (!kata || (b.nama || "").toLowerCase().includes(kata) || (b.kode || "").toLowerCase().includes(kata)));
}

// "Rp75.000" / "mulai dari Rp75.000" / null when the price is empty
export function teksHarga(b, kolom = "harga_enduser") {
  if (!b[kolom]) return null;
  return `${b.harga_mulai_dari ? "mulai dari " : ""}${rupiah(b[kolom])}`;
}

// no price at all → the page shows one "Harga sesuai pesanan"
export function tanpaHarga(b) {
  return KOLOM_HARGA.every(([k]) => !b[k]);
}
